import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import {MODULE, PageProps, PERMISSION, SECURABLE, SECURABLE_TYPE} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import Grid from "core/grid/domain/grid";
import {MovingBlocks} from "core/grid/gridUtils";
import certificateService from "administration/certificate/certificateService";
import {tabStyle} from "core/common/config/variables";
import {TabTemplate} from "core/common/config/mui-theme";
import GridComp from "core/grid/component/gridComp";
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import {action, observable} from "mobx";
import {SecuredZzFlatButton, SecuredZzUploadFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import {PAGE} from "routes";
import mdAxios, {uploadAxios} from "core/common/config/axios-config";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import {fieldStyles} from "core/form/createForm";
import {MdTextField} from "core/components/fields/fields";
import {ErrorComp} from "core/components/errorComp/errorComp";
import {ValidationMessage} from "core/common/domain/commonDomain";
import {CERTTYPE, MdCertificateBeanConfig} from "administration/certificate/certificateDomain";
import StyledSelect from "core/components/fields/styledSelect";
import {optionsSearch} from "core/common/service/commonDataService";
import {LovItem} from "core/metamodel/mdEntity";
import RaisedButton from "material-ui/RaisedButton";
import {loc} from "core/common/config/locales";


const certificateListCAROOT = 'certificateListCAROOT';
const certificateListCAINTERMEDIATE = 'certificateListCAINTERMEDIATE';
const certificateListPUBLIC = 'certificateListPUBLIC';
const certificateListPRIVATE = 'certificateListPRIVATE';





@observer
export default class CertificateList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Certificates`;
  static icon = 'certificate';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams, query) {
    console.log("CertificateList#fetchData");
    return gridService.fetchGrids(certificateListCAROOT, certificateListCAINTERMEDIATE, certificateListPUBLIC, certificateListPRIVATE)
      .then(gridLocationMap => {

        certificateService.certificateListsMV = new MovingBlocks(null, true, query.tab,
          new Grid(gridLocationMap.get(certificateListPRIVATE)),
          new Grid(gridLocationMap.get(certificateListPUBLIC)),
          new Grid(gridLocationMap.get(certificateListCAINTERMEDIATE)),
          new Grid(gridLocationMap.get(certificateListCAROOT))
        );

    });
  }

  private passwordDialogRef: ConfirmationDialog;
  @observable passwordText: string;
  @observable $errors: ValidationMessage[];

  @observable certificateOptions: LovItem[];

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    certificateService.certificateListsMV.searchExposedGrids(null);
  }

  componentWillUnmount() {
    certificateService.certificateListsMV = null;
  }


  @action onTabChange = (tabName) => {
    this.tabChange(tabName, (tab) => {
      certificateService.certificateListsMV.activeBlockTab = tab;
    });
  };


  postSuccessFn = () => {
    this.passwordText = null;
    certificateService.certificateListsMV.blockArray.forEach((grid) => grid.data = null);
    return certificateService.certificateListsMV.searchExposedGrids(null, true);
  };

  @action handleFileUpload = (files: FileList) => {

    let data = new FormData();

    let isPrivateCert: boolean = false;

    for (let i = 0; i < files.length; i++) {
      let file = files.item(i);
      data.append('certificate[' + i + ']', file, file.name);
      if ((/\.(pfx|p12)$/i).test(file.name)) isPrivateCert = true;
    }

    if (isPrivateCert) {
      return new Promise((resolve, reject) => {
        this.passwordDialogRef.open(resolve, reject);
      }).then(() => {

        return uploadAxios.post('/core/security/certificate/import', data, {params: {password: this.passwordText}, showPrettyError: true})
          .then(this.postSuccessFn, error => {
            this.$errors = error.getMessages();
          });

      }).catch((e) => {
        this.passwordText = null;
      })

    } else {
      return uploadAxios.post('/core/security/certificate/import', data, {showPrettyError: true})
        .then(this.postSuccessFn, error => {
          this.$errors = error.getMessages();
        });
    }



  };



  @action onChangePassword = (evt) => {
    this.passwordText = evt.target.value;
  };

  @action activatePrivateCertTab = (evt) => {
    console.log('activatePrivateCertTab');

    return Promise.all([certificateService.readCertificateBeanConfigs(), optionsSearch("MdCertificate", {certType: [CERTTYPE.PRIVATE]})])
      .then(([configs, options]: [MdCertificateBeanConfig[], {options: LovItem[]}]) => {
        certificateService.certificateConfigs = configs;
        this.certificateOptions = options.options;
        this.certificateOptions.unshift({value: null, label: '---'});
      } );
  };


  passwordDialogRefHandler = comp => this.passwordDialogRef = comp;

  render() {
    let {params, query} = this.props;



    const gridCompArray = [
      <GridComp grid={certificateService.certificateListsMV.getBlock(certificateListPRIVATE) as Grid}
                uiLocation={certificateService.certificateListsMV.getUiLocation(certificateListPRIVATE)} entities={mdEntityService.entityMap}/>,
      <GridComp grid={certificateService.certificateListsMV.getBlock(certificateListPUBLIC) as Grid}
                uiLocation={certificateService.certificateListsMV.getUiLocation(certificateListPUBLIC)} entities={mdEntityService.entityMap}/>,
      <GridComp grid={certificateService.certificateListsMV.getBlock(certificateListCAINTERMEDIATE) as Grid}
                uiLocation={certificateService.certificateListsMV.getUiLocation(certificateListCAINTERMEDIATE)} entities={mdEntityService.entityMap}/>,
      <GridComp grid={certificateService.certificateListsMV.getBlock(certificateListCAROOT) as Grid}
                uiLocation={certificateService.certificateListsMV.getUiLocation(certificateListCAROOT)} entities={mdEntityService.entityMap}/>,
    ];

    const tabArray = gridCompArray.map((gridComp, index) => (
      <Tab label={gridComp.props.grid.label} style={tabStyle}
           onActive={this.activateTab.bind(this, gridComp.props.grid)} key={gridComp.props.grid.getBlockName()}
           value={gridComp.props.grid.getBlockName()}>
        {gridComp}
      </Tab>
    ));

    const passwordField = <MdTextField {...fieldStyles.small.textField} value={this.passwordText} onChange={this.onChangePassword} fullWidth hintText="Password" />

    return (
      <main className="main-content">
        <ErrorComp messages={this.$errors}/>
        <ConfirmationDialog ref={this.passwordDialogRefHandler} cancelButtonText="Cancel" okButtonText="Ok" contentComponent={passwordField} title="Certificate Password"/>

        <div style={{diplay: 'flex'}}>
          <SecuredZzUploadFlatButton label="Import Certificate"  permission={PERMISSION.New} securable={PAGE.certificateDetail}
                                     handleFileUpload={this.handleFileUpload} accept=".cer,.der,.crt,.pfx,.p12,.p7b" />

        </div>


        <Tabs value={certificateService.certificateListsMV.activeBlockTab} className="detail-grid" tabTemplate={TabTemplate}
              inkBarStyle={{transition: 'inherit'}}
              contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}}
              onChange={this.onTabChange}>
          {tabArray}
          <Tab label="Private Certificate Usage" style={tabStyle} onActive={this.activatePrivateCertTab}
               value="privateCertUsage">
            {(certificateService.certificateConfigs) ? (
              <div style={{width: "100%"}}>
                <table className="zz-simple-table" style={{minWidth: '100%'}}>
                  <thead>
                  <tr>
                    <th>Private Certificate Usage</th>
                    <th>Private Certificate</th>
                  </tr>
                  </thead>
                  <tbody>
                  {
                    certificateService.certificateConfigs.map((config, index) => (
                      <tr key={index}>
                        <td>{config.beanName}</td>
                        <td style={{width: '70%'}}>
                          <StyledSelect name={'select_' + config.beanName} value={config.certificate} options={this.certificateOptions} onChange={this.onChangeCertificate.bind(this, config)}
                                        {...fieldStyles.small.styledSelect} fullWidth clearable={false}/>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <RaisedButton
                  label={loc.i18n`Save`}
                  onClick={this.onClickSave}
                  primary
                />

              </div>
            ) : null}
          </Tab>

        </Tabs>
      </main>
    );
  }


  @action onChangeCertificate(config: MdCertificateBeanConfig, newCertificate) {
    console.log('onChangeCertificate: ', newCertificate, config);
    config.certificate = newCertificate;
  };

  @action onClickSave() {
    console.log('onClickSave: ');
    return certificateService.saveCertificateBeanConfigs(certificateService.certificateConfigs);
  };


}





// WEBPACK FOOTER //
// ./src/administration/certificate/certificateList.tsx